import React from "react";
import { ArcStack, ArcButton, ArcText } from "@src/core/ui";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

interface HistoryPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const HistoryPagination: React.FC<HistoryPaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  return (
    <ArcStack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{
        paddingTop: 1,
      }}
    >
      <ArcButton
        size="small"
        disabled={currentPage === 0}
        onClick={() => onPageChange(currentPage - 1)}
        sx={{
          color: "white",
          minWidth: "24px",
          width: "24px",
          height: "24px",
          borderRadius: "20%",
          backgroundColor: "grey.800",
          "&:disabled": { color: "grey.70" },
        }}
      >
        <KeyboardArrowLeftIcon fontSize="small" />
      </ArcButton>
      <ArcText color="white" fontSize={14} fontWeight={500}>
        {currentPage + 1} of {totalPages}
      </ArcText>
      <ArcButton
        size="small"
        disabled={currentPage === totalPages - 1}
        onClick={() => onPageChange(currentPage + 1)}
        sx={{
          color: "white",
          minWidth: "24px",
          width: "24px",
          height: "24px",
          borderRadius: "20%",
          backgroundColor: "grey.800",
          "&:disabled": { color: "grey.700" },
        }}
      >
        <KeyboardArrowRightIcon fontSize="small" />
      </ArcButton>
    </ArcStack>
  );
};

export default HistoryPagination;
